export const GET_HUBSPOT_TICKETS = 'GET_HUBSPOT_TICKETS'
export const GET_HUBSPOT_TICKET = 'GET_HUBSPOT_TICKET'
export const CREATE_HUBSPOT_TICKET = 'CREATE_HUBSPOT_TICKET'
export const UPDATE_HUBSPOT_TICKET = 'UPDATE_HUBSPOT_TICKET'
export const DELETE_HUBSPOT_TICKET = 'DELETE_HUBSPOT_TICKET'
export const REPLY_HUBSPOT_TICKET = 'REPLY_HUBSPOT_TICKET'

// Native support tickets (super-admin desk via node). Strings are globally unique.
export const NATIVE_SUPPORT_TICKET_CONFIG_GET = 'NATIVE_SUPPORT_TICKET_CONFIG_GET'
export const NATIVE_SUPPORT_TICKETS_LIST_GET = 'NATIVE_SUPPORT_TICKETS_LIST_GET'
export const NATIVE_SUPPORT_TICKET_DETAIL_GET = 'NATIVE_SUPPORT_TICKET_DETAIL_GET'
export const NATIVE_SUPPORT_TICKET_CREATE = 'NATIVE_SUPPORT_TICKET_CREATE'
export const NATIVE_SUPPORT_TICKET_REPLY_CREATE = 'NATIVE_SUPPORT_TICKET_REPLY_CREATE'
